import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.sidebar');
import { OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-layout-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.sidebar/view.scss */
:host {
  display: block;
  height: 100%;
}

.hn-skip-link {
  background: var(--hn-paper);
  border-radius: var(--hn-radius-sm);
  box-shadow: var(--hn-shadow-md);
  color: var(--hn-ink);
  font-weight: 800;
  left: 16px;
  padding: 12px 16px;
  position: fixed;
  top: -80px;
  z-index: 80;
}

.hn-skip-link:focus {
  top: calc(12px + env(safe-area-inset-top));
}

.hn-app-shell {
  background: var(--hn-canvas);
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-template-rows: 64px minmax(0, 1fr);
  height: 100vh;
  overflow: hidden;
}

@supports (height: 100dvh) {
  .hn-app-shell {
    height: 100dvh;
  }
}
.hn-shell-navigation {
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  position: relative;
  z-index: 40;
}

.hn-app-main {
  background: radial-gradient(circle at 94% -8%, rgba(169, 201, 92, 0.1), transparent 24rem), var(--hn-canvas);
  grid-column: 1;
  grid-row: 2;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-padding-top: 20px;
}

.hn-route-announcer {
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
}

.hn-loading {
  -webkit-backdrop-filter: blur(7px);
  align-items: center;
  backdrop-filter: blur(7px);
  background: rgba(18, 21, 18, 0.26);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  z-index: 100;
}

.hn-loading__spinner {
  animation: hn-shell-spin 0.75s linear infinite;
  border: 3px solid rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  border-top-color: var(--hn-accent);
  height: 38px;
  width: 38px;
}

@keyframes hn-shell-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 900px) {
  .hn-app-shell {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: calc(54px + env(safe-area-inset-top)) minmax(0, 1fr);
  }
  .hn-shell-navigation {
    grid-column: 1;
    grid-row: 1;
    padding-top: env(safe-area-inset-top);
  }
  .hn-app-main {
    grid-column: 1;
    grid-row: 2;
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
    scroll-padding-top: 10px;
  }
}`],
})
export class LayoutSidebarComponent implements OnInit, OnDestroy {
    public routeAnnouncement = '';
    private routerSubscription: Subscription | null = null;

    constructor(@Inject( Service) public service: Service,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        this.routerSubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                setTimeout(() => this.restoreContentScroll(event.urlAfterRedirects), 0);
            }
        });
        setTimeout(() => this.restoreContentScroll(location.pathname + location.hash), 0);
    }

    public ngOnDestroy() {
        this.routerSubscription?.unsubscribe();
        this.routerSubscription = null;
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0;
    }

    private restoreContentScroll(url: string) {
        const main = document.querySelector('.hn-app-main') as HTMLElement;
        if (!main) return;

        const pathname = url.split('#')[0].split('?')[0];
        const titles: any = {
            '/dashboard': '운용 현황',
            '/target': '종목 선택',
            '/history': '거래 기록',
            '/settings': '서비스 설정',
            '/mypage': '내 정보'
        };
        const pageTitle = titles[pathname] || 'HANNOM';
        document.title = pageTitle === 'HANNOM' ? 'HANNOM — 한놈만 팬다' : pageTitle + ' | HANNOM';
        this.routeAnnouncement = pageTitle + ' 화면';

        const fragment = url.split('#')[1];
        if (!fragment) {
            main.scrollTo({ top: 0, behavior: 'auto' });
            const heading = main.querySelector('h1') as HTMLElement;
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus({ preventScroll: true });
            }
            return;
        }

        const target = document.getElementById(decodeURIComponent(fragment));
        if (target) {
            target.setAttribute('tabindex', '-1');
            const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            target.scrollIntoView({ block: 'start', behavior: reduceMotion ? 'auto' : 'smooth' });
            target.focus({ preventScroll: true });
        }
    }
}

export default LayoutSidebarComponent;